export type NameParts = { firstName: string; lastName: string };

const SURNAME_PARTICLES = new Set([
  'van',
  'von',
  'de',
  'del',
  'della',
  'der',
  'den',
  'da',
  'das',
  'di',
  'do',
  'dos',
  'du',
  'la',
  'le',
  'bin',
  'ibn',
  'al',
  'el',
]);

const GENERATIONAL_SUFFIXES = new Set(['jr', 'sr', 'ii', 'iii', 'iv']);

const bare = (token: string) => token.toLowerCase().replace(/\.$/, '');

const startOfLastName = (tokens: string[]): number => {
  let start = tokens.length - 1;
  if (start > 1 && GENERATIONAL_SUFFIXES.has(bare(tokens[start]))) start -= 1;
  while (start > 1 && SURNAME_PARTICLES.has(bare(tokens[start - 1])))
    start -= 1;
  return start;
};

const wordsOf = (text: string) => text.trim().split(/\s+/).filter(Boolean);

/** One or two words, which split the same on the device as by the AI. */
export const isPlainName = (text: string): boolean => {
  const count = wordsOf(text).length;
  return count > 0 && count <= 2;
};

/**
 * Splits a typed full name: the last word (with any particle or suffix that
 * belongs to it) is the last name, everything before is the first name.
 */
export const splitFullName = (text: string): NameParts => {
  const tokens = wordsOf(text);
  if (tokens.length <= 1) return { firstName: tokens[0] ?? '', lastName: '' };

  const start = startOfLastName(tokens);
  return {
    firstName: tokens.slice(0, start).join(' '),
    lastName: tokens.slice(start).join(' '),
  };
};
